import { TimelineLite } from "gsap";
import { TimelineMax } from "gsap";



export class TimelineLiteEx extends TimelineLite
{
    public addDelay (delay: number, position?: number | string) 
    {
        let delayAttr;
        if (typeof delay === 'undefined' || isNaN(delay)) {
            return this;//skip if invalid parameters
        }
        if (typeof position === 'undefined') {
            delayAttr = '+=' + delay; //add delay at the end of the timeline
        } else if (typeof position === 'string') {
            delayAttr = position + '+=' + delay; //add delay after label
        } else if (!isNaN(position)) {
            delayAttr = delay + position; //if they're both numbers, assume absolute position
        } else {
            return this; //nothing done
        }
    
        return this.set({}, {}, delayAttr);
    };
}

export class TimelineMaxEx extends TimelineMax
{
    public addDelay (delay: number, position?: number | string) 
    {
        let delayAttr;
        if (typeof delay === 'undefined' || isNaN(delay)) {
            return this;//skip if invalid parameters
        }
        if (typeof position === 'undefined') {
            delayAttr = '+=' + delay; //add delay at the end of the timeline
        } else if (typeof position === 'string') {
            delayAttr = position + '+=' + delay; //add delay after label
        } else if (!isNaN(position)) {
            delayAttr = delay + position; //if they're both numbers, assume absolute position
        } else {
            return this; //nothing done
        }
    
        return this.set({}, {}, delayAttr);
    };
}